import { parseCellKey } from 'components/CellAnnotationValueViewer/types';
import type {
  CellAnnotationWireEntry,
  CellAnnotationWireMap,
} from 'components/CellAnnotationValueViewer/types';
import type { WireByCellKey } from './types';

// Split a dirty cell-annotation payload into the bucket the CFL bulk-save
// writer needs: one cell_annotations map per CashFlowLedgerItem parent,
// keyed by id. Every annotation type (pre_fx_currency, cross_reference,
// future) folds through the same `(parentId → fieldAlias → annotationType →
// entry)` shape — same as the FOD splitter.

export interface SplitDirtyForCflSave {
  cflCellAnnotations: Record<string, CellAnnotationWireMap>;
}

const foldEntry = (
  bucket: Record<string, CellAnnotationWireMap>,
  parentId: string,
  fieldAlias: string,
  annotationType: string,
  entry: CellAnnotationWireEntry
): void => {
  // eslint-disable-next-line no-param-reassign
  const forParent = bucket[parentId] ?? (bucket[parentId] = {});
  const forField = forParent[fieldAlias] ?? (forParent[fieldAlias] = {});
  forField[annotationType as keyof typeof forField] = entry;
};

export const splitDirtyForCflSave = (payload: WireByCellKey): SplitDirtyForCflSave => {
  const result: SplitDirtyForCflSave = { cflCellAnnotations: {} };

  if (!payload) {
    return result;
  }

  Object.entries(payload).forEach(([cellKey, entry]) => {
    const parsed = parseCellKey(cellKey);
    if (!parsed || parsed.parentType !== 'cashflowledgeritem') return;
    foldEntry(
      result.cflCellAnnotations,
      parsed.parentId,
      parsed.fieldAlias,
      parsed.annotationType,
      entry as CellAnnotationWireEntry
    );
  });

  return result;
};
